import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { RestApiError } from 'src/app/common-components/errors/models/error-message';
import { ActiveCallsRegisterListItem } from '../models/active-calls-register-results.model';
import { ActiveCallsRegisterApiService } from '../services/active-calls-register-api.service';

@Component({
    selector: 'ndt-active-call-hangup-confirmation-dialog',
    templateUrl: './active-call-hangup-confirmation-dialog.component.html',
    styleUrls: ['./active-call-hangup-confirmation-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ActiveCallHangupConfirmationDialogComponent {
   title: string = 'Call Hangup Confirmation';
   message: string = 'Are you sure you want to hang up this call?';
   isLoading = true;
   callStatusMessage: string = 'Call Status not found';
   isCallActive: boolean = false;
   isRoutingToEmptyExitRouteAndCallIsNotActive: boolean = false;
   constructor(
      @Inject(MAT_DIALOG_DATA)
      public data: {
         title: string;
         message: string;
         activeCall: ActiveCallsRegisterListItem;
         isRoutingToEmptyExitRoute: boolean;
      },
      private dialogRef: MatDialogRef<ActiveCallHangupConfirmationDialogComponent>,
      private activeCallsRegisterApiService: ActiveCallsRegisterApiService
   ) {
      this.message = data.message;
      if (data.title) {
         this.title = data.title;
      }
      this.activeCallsRegisterApiService
         .checkIfCallActive(
            data.activeCall.serverName?.split(',')[0] ?? null,
            data.activeCall.callerChannelId,
            data.activeCall.callDetailId
         )
         .pipe(take(1))
         .subscribe({
            next: (result) => {
               this.isLoading = false;
               this.isCallActive = result;
               if (result) {
                  this.callStatusMessage = data.isRoutingToEmptyExitRoute
                     ? ''
                     : 'Call status: Active. Proceeding will terminate the ongoing call.';
               } else {
                  this.callStatusMessage = data.isRoutingToEmptyExitRoute
                     ? 'No active call was found on the server. Unable to route call'
                     : 'No active call was found on the server. It is safe to hang up.';
                  this.isRoutingToEmptyExitRouteAndCallIsNotActive = data.isRoutingToEmptyExitRoute;
               }
            },
            error: (err: RestApiError) => {
               this.isLoading = false;
               this.callStatusMessage =
                  'Connection to the server timed out while checking call status. The call is likely no longer active.';
            },
         });
   }

   onConfirm() {
      this.dialogRef.close(true);
   }

   onCloseClick(): void {
      this.dialogRef.close(false);
   }
}
